import React from "react";
import "../styles/Navbar.css"; // You can style this component in a separate CSS file
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

const Navbar = () => {
  const location = useLocation();
  const pageInfo = {
    "/ourcenters": {
      title: "Our Centers",
      subtitle: "Find specialized respiratory care and support.",
    },
    "/drbach": {
      title: "Dr. Bach",
      subtitle:
        "Learn about Dr. John R. Bach and his approach to respiratory care.",
    },
    "/resources": {
      title: "Resources",
      subtitle:
        "Information and resources for patients, families, and healthcare professionals.",
    },
    "/about": {
      title: "About DoctorBach",
      subtitle:
        "Learn more about DoctorBach and our commitment to respiratory care.",
    },
  };

  const currentPage = pageInfo[location.pathname] || {
    title: "DoctorBach",
    subtitle: "Noninvasive respiratory support and care.",
  };
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const isHomePage = location.pathname === "/";
  return (
    <div className="nav-section">
      {" "}
      <div className="nav-area">
        {" "}
        <nav className="navbar-container">
          {" "}
          <div className="navbar">
            {" "}
            <Link
              to="/"
              className="logo-link"
            >
              {" "}
              <div className="logo-container">
                {" "}
                <h2>DoctorBach</h2>{" "}
              </div>{" "}
            </Link>{" "}
            <button className="menu-toggle" onClick={toggleMenu}>
              {" "}
              ☰{" "}
            </button>{" "}
          </div>{" "}
          <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
            {" "}
            <li>
              {" "}
              <Link to="/" onClick={toggleMenu}>
                {" "}
                Home{" "}
              </Link>{" "}
            </li>{" "}
            <li>
              {" "}
              <Link to="/ourcenters" onClick={toggleMenu}>
                {" "}
                Our Centers{" "}
              </Link>{" "}
            </li>{" "}
            <li>
              {" "}
              <Link to="/drbach" onClick={toggleMenu}>
                {" "}
                Dr. Bach{" "}
              </Link>{" "}
            </li>{" "}
            <li>
              {" "}
              <Link to="/resources" onClick={toggleMenu}>
                {" "}
                Resources{" "}
              </Link>{" "}
            </li>{" "}
            <li>
              {" "}
              <Link to="/about" onClick={toggleMenu}>
                {" "}
                About{" "}
              </Link>{" "}
            </li>{" "}
          </ul>{" "}
        </nav>{" "}
        {isHomePage ? (
          /* HOME PAGE */ <div className="center-container home-hero">
            {" "}
            <img
              src="../images/vent.jpg"
              alt="Noninvasive Ventilation Illustration"
            />{" "}
            <div className="quote">
              {" "}
              <p className="qoute-txt">
                {" "}
                "No person with neuromuscular disease, nor anyone else, no
                matter how weak their muscles are, should ever require a trach
                tube or develop any respiratory complications if people only
                learn what we have known for 48 years."{" "}
              </p>{" "}
              <p className="quote-src">- Dr. John R. Bach</p>{" "}
            </div>{" "}
            <div className="hero-content">
              {" "}
              <h1>Noninvasive Ventilation Support</h1>{" "}
              <p>A Better Approach to Respiratory Support</p>{" "}
              <div className="hero-buttons">
                {" "}
                <Link to="/resources" className="btn primary-btn">
                  {" "}
                  Resources{" "}
                </Link>{" "}
                <Link to="/ourcenters" className="btn secondary-btn">
                  {" "}
                  Our Centers{" "}
                </Link>{" "}
              </div>{" "}
            </div>{" "}
          </div>
        ) : (
          /* OTHER PAGES */ <div className="page-banner">
            <div className="page-intro">
              <h1>{currentPage.title}</h1>
              <p>{currentPage.subtitle}</p>
            </div>

            <div className="page-quote">
              <p className="qoute-txt">
                "No person with neuromuscular disease, nor anyone else, no
                matter how weak their muscles are, should ever require a trach
                tube or develop any respiratory complications if people only
                learn what we have known for 48 years."
              </p>

              <p className="quote-src">- Dr. John R. Bach</p>
            </div>
          </div>
        )}{" "}
      </div>{" "}
    </div>
  );
};

export default Navbar;
